<template>
  <div v-if="htmlCaption">
    <div
      v-if="htmlCaption.groupItems"
      class="ml-7 my-2"
      :style="`display: flex;flex-direction: ${
        htmlCaption.vertical ? 'column' : 'row'
      }`"
    >
      <div
        class="mb-2"
        v-for="(groupItem, index) in htmlCaption.groupItems"
        :key="index"
      >
        <strong class="mx-1 white--text" v-if="groupItem.text">{{
          groupItem.text
        }}</strong>
        <div class="my-1" v-for="(item, index) in groupItem.items" :key="index">
          <v-icon :color="item.color">{{
            item.style ? item.style : 'circle'
          }}</v-icon>
          <span class="mr-1 ml-1 customText">{{ item.text }}&nbsp;</span>
        </div>
      </div>
      <div v-if="htmlCaption.unit" class="mb-2">
        <div class="my-1">
          <span class="mr-1 ml-1 textItemSuffix">&nbsp;({{ htmlCaption.unit }})</span>
        </div>
      </div>
    </div>
    <div
      v-else
      class="ml-7 my-2"
      :style="`display: flex;flex-direction: ${
        htmlCaption.vertical ? 'column' : 'row'
      }`"
    >
      <div class="my-2" v-for="(item, index) in htmlCaption.items" :key="index">
        <v-icon :color="item.color">{{
          item.style ? item.style : 'circle'
        }}</v-icon>
        <span class="mr-1 ml-1 customText">{{ item.text }}&nbsp;</span>
      </div>
      <div v-if="htmlCaption.unit" class="mb-2">
        <div class="my-1">
          <span class="mr-1 ml-1 textItemSuffix">&nbsp;({{ htmlCaption.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HtmlLEgendSublayer',
  props: ['htmlCaption'],
};
</script>

<style scoped>
.customText {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0em;
}
.textItemSuffix {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
}
</style>
